import React, { useState } from 'react';
import './Login.css';
import logger from '../../utils/logger';


const Login = ({ onNavigate, onLoginSuccess }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  //hay unas variables de entorno que son el archivo .env y el .env.production
  //en el archivo .env.production se encuentran las variables de entorno para producción
  //en el archivo .env se encuentran las variables de entorno para desarrollo
  //esto setea la ruta del servidor dependiendo de si estamos en producción o desarrollo
  const API_URL = process.env.REACT_APP_API_URL || '';


  const handleSubmit = async (e) => {
    e.preventDefault();

    // 📝 Log intento de login
    logger.info('Intento de login', {
      tipo: 'LOGIN_ATTEMPT',
      datos: { usuario: username }
    });

    try {
      // escribo la ruta asi porque en el archivo .env tengo la variable REACT_APP_API_URL que es la url del servidor en desarrollo
      // en producción la url es diferente, por eso uso {API_URL} para que se adapte a la url del servidor
      const response = await logger.fetchWithLogging(`${API_URL}/api/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ usuario: username, password })
      });

      if (response.ok) {
        const data = await response.json();

        // 🔧 Configurar usuario en el logger
        logger.setUser(data.user.usuario);

        // ✅ Log login exitoso
        logger.info('Login exitoso', {
          tipo: 'LOGIN_SUCCESS',
          datos: { usuario: data.user.usuario, nombre: data.user.nombre }
        });

        onLoginSuccess(data.user); // ⬅️ Guardamos el usuario
      } else {
        const err = await response.json();
        const errorMsg = err.message || 'Credenciales incorrectas';

        // ❌ Log login fallido
        logger.warn('Login fallido', {
          tipo: 'LOGIN_FAILED',
          datos: { usuario: username, error: errorMsg, status: response.status }
        });

        setError(errorMsg);
      }
    } catch (err) {
      // ❌ Log error de conexión
      logger.error('Error de conexión en login', {
        tipo: 'LOGIN_CONNECTION_ERROR',
        datos: { usuario: username, error: err.message }
      });

      setError('Error al conectar con el servidor');
    }
  };


  return (
    <div className="login-container">
      <div className="login-box">
        <div className="avatar"></div>
        <form className="login-form" onSubmit={handleSubmit}>
          <div className="input-group">
            <label>Nombre de usuario</label>
            <input
              type="text"
              placeholder="Nombre de usuario"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>
          <div className="input-group">
            <label>Contraseña</label>
            <input
              type="password"
              placeholder="Introduce tu contraseña"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <div className="options">
            <label>
              <input type="checkbox" />
              Recuérdame
            </label>
            <a
              href="https://wa.me/34643535545?text=Olvidé%20mi%20contraseña"
              target="_blank"
              rel="noopener noreferrer"
            >
              ¿Olvidaste tu contraseña?
            </a>

          </div>
          <button className="login-button" type="submit">LOGIN</button>
          {error && <p className="error-message">{error}</p>}
        </form>
      </div>
    </div>
  );
};


export default Login;
